/* eslint-disable no-restricted-imports */

'use client';

import React from 'react';
import { Grid, GridItem, IBreakpointName } from '../../../../ui';
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import NewsSectionWrapper from './NewsSectionWrapper';
import { IBlogItemEntry } from '../../../shared/api/contentful/types/IBlogItem';
import NewsCardNoImage from '../../../../../assets/icons/no-image.svg?reference';
import NewsCard from './NewsCard';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { getMaxWidthBasedOnColumns } from '../../helpers/getMaxWidthBasedOnColumns';
import Responsive from '../../../../ui/utils/Responsive';
import truncateText from '../../helpers/truncateText';

export interface IBlogItemProps {
	recentBlogItems: IBlogItemEntry[];
}

export const TheWindowSeatSection = ({ recentBlogItems }: IBlogItemProps) => {
	const isTabletXL = Responsive.useMatchesBreakpoint('tabletXL');
	const { t } = useTranslation();
	const router = useRouter();

	if (!recentBlogItems || recentBlogItems.length === 0) {
		return null;
	}

	return (
		<NewsSectionWrapper
			title={t('newsroom_blogs_page_title')}
			label={t('newsroom_landing_blogs_label')}
			viewAllButtonLabel={t('web_view_all_blog_items')}
			viewAllHref={`${router.asPath}blogs`}
		>
			<StyledGrid>
				{recentBlogItems.map((item) => {
					const imageSrc =
						item.fields.images?.[0]?.fields?.file?.url || NewsCardNoImage;

					return (
						<StyledGridItem
							key={item.fields.slug}
							columns={[2, { mobileXL: 12 }]}
						>
							<NewsCard
								variant={isTabletXL ? 'vertical' : 'horizontal'}
								title={item.fields.title}
								summary={truncateText(item.fields.body, 200)}
								summaryTruncated
								publicationDate={item.fields.publicationDate}
								linkHref={`${router.asPath}blogs/item/${item.fields.slug}`}
								imageSource={imageSrc}
								category={item.fields.category}
								categoryLabelLeftTop
							/>
						</StyledGridItem>
					);
				})}
			</StyledGrid>
		</NewsSectionWrapper>
	);
};

const StyledGrid = styled(Grid.withComponent('ul'))`
	margin-top: 0;
	margin-left: 0;
	padding-left: 0;
	list-style: none;
	gap: 8px;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-bottom: 16px;
	}
`;

const StyledGridItem = styled(GridItem.withComponent('li'))<{
	columns: number | [number, Partial<{ [key in IBreakpointName]: number }>];
}>`
	display: block;
	margin-top: 0;
	margin-left: 0;
	padding-left: 0;
	flex: 1;
	${({ columns }) => getMaxWidthBasedOnColumns(columns)};
`;
